import { useState } from "react";
import { it } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const label = (v) => new Date(`${v}T12:00:00`).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });

export default function DateField({ value, onChange, min, placeholder = "gg/mm/aaaa", testid }) {
  const minDate = min ? new Date(`${min}T00:00:00`) : undefined;
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" className="h-8 w-36 justify-start px-2.5 text-xs font-normal" data-testid={testid}>
          <CalendarDays size={13} className="mr-1.5 text-slate-400" />{value ? label(value) : <span className="text-slate-400">{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={it} weekStartsOn={1} selected={value ? new Date(`${value}T12:00:00`) : undefined}
          defaultMonth={value ? new Date(`${value}T12:00:00`) : minDate} disabled={minDate ? { before: minDate } : undefined}
          onSelect={(d) => { if (d) { onChange(toIso(d)); setOpen(false); } }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
